import { Button } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import {
    EMPTY_STATE_BANNER_BTN_TEXT,
    EMPTY_STATE_BANNER_SUB_TITLE_TEXT,
    EMPTY_STATE_BANNER_TITLE_TEXT,
} from "app/pages/activation/components/EmptyStateBunner/texts";
import { EMPTY_PROJECT_FOLDERS_SRC } from "app/pages/activation/components/ProjectsList/constants";
import { statesDataAutomation } from "app/pages/activation/components/ProjectsList/dataAutomationKeys";
import { AssetsService } from "app/services/AssetsService";

import * as SC from "./styles";

type EmptyStateFoldersVariantSchema = {
    onClick: () => void;
};

export const EmptyStateFoldersVariant = ({ onClick }: EmptyStateFoldersVariantSchema) => (
    <SC.Container data-automation={statesDataAutomation.empty}>
        <SC.EmptyImage src={AssetsService.assetUrl(EMPTY_PROJECT_FOLDERS_SRC)} />

        <SC.Content>
            <SC.Subtitle>{translate(EMPTY_STATE_BANNER_TITLE_TEXT)}</SC.Subtitle>
            <SC.Body>{translate(EMPTY_STATE_BANNER_SUB_TITLE_TEXT)}</SC.Body>
        </SC.Content>

        <Button
            onClick={onClick}
            type="primary"
            dataAutomation={statesDataAutomation.emptyButton}
        >
            {translate(EMPTY_STATE_BANNER_BTN_TEXT)}
        </Button>
    </SC.Container>
);
